import { getIntegrationUrl } from 'routes/Integrations/helpers'
import { INTEGRATION_QUERIES } from 'routes/constants'
import { Markdown, StyledMarkdownWrapper } from 'routes/components/Shared'
import NavLink from 'ui-kit/actions/link/NavLink'
import clsx from 'clsx'
import common from 'routes/Integrations/Integration/Integration.module.scss'
import classes from './Operations.module.scss'

export function IntegrationOperationsCard({ operation, integrationLink }) {
  const { key, name, description } = operation

  return (
    <li className={clsx(common.integrationItem, classes.item)}>
      <NavLink
        className={clsx(common.integrationLink, classes.link)}
        href={getIntegrationUrl(
          integrationLink,
          INTEGRATION_QUERIES.OPERATIONS,
          key,
        )}
      >
        {name}
      </NavLink>

      {description && (
        <StyledMarkdownWrapper className={classes.description}>
          <Markdown>{description}</Markdown>
        </StyledMarkdownWrapper>
      )}
    </li>
  )
}
